import { connect } from 'react-redux';
import { Dispatch } from 'react';

import SendBox from '../components/SendBox';
import { sendMessage, sendTypingNotification, sendFile } from '../core/sideEffects';
import { Constants } from '../core/constants';
import { State } from '../core/reducers';
import { setWhomToChat } from '../core/actions/MessagesAction';

const mapStateToProps = (state: State) => ({
  user: state.contosoClient.user,
  groupId: state.calls.group,
  threadId: state.thread.threadId,
  remoteParticipants: state.calls.remoteParticipants,
  chatwith: state.chat.whom,
});

const mapDispatchToProps = (dispatch: any) => ({
  onSendMessage: (messageContent: any) => dispatch(sendMessage(messageContent)),
  onSendTypingNotification: (
    lastSentTypingNotificationDate: number,
    setLastSentTypingNotificationDate: Dispatch<number>
  ) => {
    let currentDate = new Date();
    let timeSinceLastSentTypingNotificationMs = currentDate.getTime() - lastSentTypingNotificationDate;
    if (timeSinceLastSentTypingNotificationMs >= Constants.MINIMUM_TYPING_INTERVAL_IN_MILLISECONDS) {
      dispatch(sendTypingNotification());
      setLastSentTypingNotificationDate(currentDate.getTime());
    }
  },
  onSendFile: (file: File) => dispatch(sendFile(file)),
  setWhomToChat: (whom: any) => dispatch(setWhomToChat(whom))
});

export default connect(mapStateToProps, mapDispatchToProps)(SendBox);
